import Component from './assistant-card-interior'

export default Component
